export const PROVIDERS_TABLE_HEAD = [
  { id: 'emptyCell' },
  { id: 'first_name', label: 'Name', align: 'left' },
  { id: 'email', label: 'Email', align: 'left' },
  { id: 'rating', label: 'Rating', align: 'left' },
  { id: 'jobs_completed', label: 'Jobs Completed', align: 'left' },
  { id: 'is_chat_user', label: 'Chat', align: 'left' },
  { id: 'created_at', label: 'Created at', align: 'left' },
  { id: 'user_statuses.display', label: 'Status', align: 'left' },
  { id: 'actionBtns' },
];
